import { createRoot } from 'react-dom/client';
import './index.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import App from './App';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

const rumApplicationId = import.meta.env.REACT_APP_RUM_APPLICATION_ID;
const rumClientToken = import.meta.env.REACT_APP_RUM_CLIENT_TOKEN;

if (rumApplicationId && rumClientToken) {
  datadogRum.init({
    applicationId: rumApplicationId,
    clientToken: rumClientToken,
    site: 'datadoghq.com',
    service: 'recipient-web',
    env: import.meta.env.REACT_APP_RUM_ENV,
    version: import.meta.env.REACT_APP_RUM_VERSION,
    sessionSampleRate: parseInt(import.meta.env.REACT_APP_RUM_SESSION_SAMPLE_RATE, 10) || 100,
    sessionReplaySampleRate: parseInt(import.meta.env.REACT_APP_RUM_SESSION_REPLAY_SAMPLE_RATE, 10) || 10,
    traceSampleRate: parseInt(import.meta.env.REACT_APP_RUM_TRACE_SAMPLE_RATE, 10) || 10,
    trackUserInteractions: true,
    trackResources: true,
    trackFrustrations: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [/https:\/\/.*\.gojitsu\.com/, /https:\/\/.*\.axlehire\.com/],
    enableExperimentalFeatures: ['clickmap'],
  });
  datadogRum.startSessionReplayRecording();

  datadogLogs.init({
    clientToken: rumClientToken,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
